'use client';

import { Button, Modal } from '@common/components';

interface TossExitConfirmModalProps {
  opened: boolean;
  onClose?: () => void;
  onConfirm?: () => void;
}

export const TossExitConfirmModal = ({
  opened,
  onClose,
  onConfirm,
}: TossExitConfirmModalProps) => {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      header="토스로 이동"
      description="토스 앱으로 이동하시겠습니까?"
      buttonFooter={
        <>
          <Button theme="sub-line" onClick={onClose}>
            취소
          </Button>
          <Button onClick={onConfirm}>이동</Button>
        </>
      }
    />
  );
};
